import React, { useEffect, useState } from "react";
import { Col, Modal, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";



function Scorecard({totalscore,type}) {

  const navigate = useNavigate()

    const [scoremodal, setScoremodal] = useState(true);

      const {
         questiondetails
       } = useSelector((state) => state?.user);
 console.log("totalscore",totalscore,type)

  const [toatalScore, setTotalScore] = useState(totalscore); 
  const [investmentType,setInvestmentType]=useState("");


   const handleClick = () => {
    navigate("/vac-score-system", {
      state: {
          investmentType
      },
    });
  };



  useEffect(()=>{
    if(totalscore){
      let txt = questiondetails?.interpretation
      .slice(0,questiondetails?.interpretation.length -1)
      .find(val=> toatalScore >= Object.values(val)[0].split(" ")[0] && toatalScore <= Object.values(val)[0].split(" ")[2])
      console.log("txt",txt);
     setInvestmentType(Object.keys(txt ?? {})[0])
    }
  },[totalscore])

    return (
    <div>
   

             <Table bordered hover responsive  className={`mb-0 ${type=== "interpretation" ? '' : 'scoretype'}`}>
                      <thead>
                        <tr>
                          <th className="hno">Investment  {type=== "interpretation" ? "Interpretation" : "Type"}</th>
                          <th className="hno">Total Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        {console.log(questiondetails?.interpretation,"questiondetails?.interpretation")}
                        
                        {
                          questiondetails?.interpretation?.length > 0 && 
                          questiondetails?.interpretation?.map((val,i)=>{
                            
                               console.log("Object.values(val)[0]",Object.values(val)[0].split(" "),toatalScore)
                            return(
                            <tr>
                           
                         {type=== "interpretation" ?
                         
                            <td>{Object.keys(val)[0]}</td>
                             :
                             <td>
                             { i !==  questiondetails?.interpretation?.length - 1 &&
                              <p className="mb-0">{Object.keys(val)[0]}</p>}
                             </td>                              
                             }


                            {type=== "interpretation" ?
                            <td>
                              { i ==  questiondetails?.interpretation?.length - 1 &&
                                <>
                                 <p onClick={handleClick} className={`investmentclr cursor-pointer ${investmentType.replaceAll(" ","").toLocaleLowerCase()}`}>{investmentType}</p>
                                </> }
                                {Object.values(val)[0]}
                                </td>
                                :
                               <td>
                               { i !==  questiondetails?.interpretation?.length - 1 &&
                               <p className="mb-0">{Object.values(val)[0]}</p> }
                                </td>
                              }


                          </tr>
                            )
                          })
                        }
                      </tbody>
                    </Table>


    </div>

       )

}


export default Scorecard;